
import { Component, Input, OnInit } from "@angular/core";
import { CommonService } from "../../services/common.service";

@Component({
  selector: 'app-player-orders-detail-card',
  templateUrl: './player-orders-detail-card.html',
  styleUrls: ['./player-orders-detail-card.scss']
})
export class PlayerOrdersDetailCardComponent implements OnInit {

    @Input() orderDetails:any;
    paidItems:any=[];
    currentUser:any;

  constructor(
    private commonService: CommonService
  ) { }
  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);

    this.commonService.orderIdPlayer$.subscribe((id:any)=>{
      this.orderDetails ={};
      this.paidItems = [];
      this.getOrderDetailsPlayer(id)
    })
  }

  getOrderDetailsPlayer(id:any){
    this.commonService.playergetOrdersById(id).subscribe((res:any)=>{
      if(res.status == 200){
        this.orderDetails = res.output[0];
        for(var j of this.orderDetails?.items){
          if(j?.isFreeQuantity!=j?.quantity){
            this.paidItems.push(j)  
          }
        }
      }
    })
  }

  convertToDecimal(data:any){
    return data ? data?.toFixed(2) : 0;
  }
  formatEventDate(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "Aug 17, 2025"
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }

  formatEventTime(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "3:30 PM"
    return d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }
  cancelOrder(payment:any){

  }
}
